module.exports = __webpack_public_path__ + "img/pager.15412daf.png";